import logdna from "@logdna/browser";

export const initLogDna = (): void => {
  const isLocal = import.meta.env.VITE_APP_ENV === "local";

  if (!isLocal && import.meta.env.VITE_LOGDNA_INGESTION_KEY) {
    // Initialize LogDNA logger
    logdna.init(import.meta.env.VITE_LOGDNA_INGESTION_KEY, {
      // Context is appended to the metadata of each message sent to LogDNA
      // Add any custom meta data such as:
      env: import.meta.env.VITE_APP_ENV,
      console: {
        enable: false,
      },
      hostname: `kaboodle-${import.meta.env.VITE_APP_ENV}-ui`,
      app: `kaboodle-ui`,
      tags: ["react"],
    });
  }
};

export const logToLogDna = (
  level: "info" | "warn" | "error",
  message: string,
  meta?: Record<string, unknown>,
): void => {
  // only use this when necessary and do not use excessively to avoid performance issues
  // also do not pass sensitive information

  const isLocal = import.meta.env.VITE_APP_ENV === "local";

  if (!isLocal && import.meta.env.VITE_LOGDNA_INGESTION_KEY) {
    switch (level) {
      case "info":
        logdna.log(message, meta);
        break;
      case "warn":
        logdna.warn(message, meta);
        break;
      case "error":
        logdna.error(message, meta);
        break;
      default:
        logdna.log(message, meta);
    }
  } else {
    // eslint-disable-next-line no-console
    console.log(`LogDNA [${level}]: ${message}`, meta || "");
  }
};
